import { version } from "../package.json";

export default {
  API_BASEURL: process.env.API_BASEURL || process.env.NEXT_PUBLIC_API_BASEURL,
  WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
  UNIVERSE_WEB_SECRET_KEY: process.env.NEXT_PUBLIC_UNIVERSE_WEB_SECRET_KEY,
  APP_VERSION: version,
  ANALYTICS_API_KEY: process.env.NEXT_PUBLIC_ANALYTICS_API_KEY,
  RECAPTCHA_ENTERPRISE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_ENTERPRISE_KEY,
  BLOG_URL: process.env.NEXT_PUBLIC_BLOG_URL,
  GPT_AD_PATH: process.env.NEXT_PUBLIC_GPT_AD_PATH,
  GPT_AD_TARGET_ID: process.env.NEXT_PUBLIC_GPT_AD_TARGET_ID,
  GPT_AD_PATH_EDUCATOR: process.env.NEXT_PUBLIC_GPT_AD_PATH_EDUCATOR,
  GPT_AD_TARGET_ID_EDUCATOR: process.env.NEXT_PUBLIC_GPT_AD_TARGET_ID_EDUCATOR,
  GPT_AD_PATH_FAMILY: process.env.NEXT_PUBLIC_GPT_AD_PATH_FAMILY,
  GPT_AD_TARGET_ID_FAMILY: process.env.NEXT_PUBLIC_GPT_AD_TARGET_ID_FAMILY,
};
